import React from 'react';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
interface Props {
  isCalculated: boolean;
  isCorrectAnswer: boolean;
}

const RenderStatusIcon: React.FC<Props> = (props: Props): React.ReactNode => {
    if (props.isCalculated) {
        return <div className="compendium-grid__item-answer-status">
            <SpriteIcon name={props.isCorrectAnswer ? '#svg-check' : '#svg-bet-slip-controller-close'}
                className="svg-default compendium-grid__item-answer-icon"/>
        </div>;
    }
    return <></>;
};

export default RenderStatusIcon;
